import React from 'react';

import { CommonTheme, useCurrentTheme } from 'app/shared/theme';
import { WithPositionProps } from 'app/shared/components/styleUtils';
import { Icon } from 'app/shared/components/atoms';
import { Box } from 'app/shared/components/atoms';
import { ReactComponent as CheckCircle } from 'icons/circle-check.svg';
import { ReactComponent as ResetIcon } from 'icons/close.svg';
import { ReactComponent as AlertCircle } from 'icons/info.svg';

interface Props extends WithPositionProps {
  iconType?: 'ERROR' | 'SUCCESS' | 'RESET' | null;
  onClickResetInput?: () => void;
  invertColors?: boolean;
  backgroundColor?: string;
  'data-qaid'?: string;
}

export const InputStatusIcon: React.FC<React.PropsWithChildren<Props>> = ({
  iconType,
  onClickResetInput = () => {},
  invertColors,
  backgroundColor,
  'data-qaid': qaId = 'input-status-icon',
}) => {
  const theme = useCurrentTheme() as CommonTheme;

  if (!iconType) {
    return null;
  }

  const fillColor = backgroundColor
    ? backgroundColor
    : invertColors
      ? theme.colors.input.inverted.background
      : theme.colors.input.default.background;

  const iconsConfig: Record<string, any> = {
    ERROR: {
      icon: AlertCircle,
      strokeColor:
        theme.colors.messaging.error[invertColors ? 'light' : 'dark'],
      fillColor,
      onClickAction: () => {},
    },
    SUCCESS: {
      strokeColor:
        theme.colors.messaging.success[invertColors ? 'light' : 'dark'],
      icon: CheckCircle,
      fillColor,
      onClickAction: () => {},
    },
    RESET: {
      strokeColor: invertColors
        ? theme.colors.accent.primaryAccent.base
        : theme.colors.primary.black.base,
      fillColor,
      icon: ResetIcon,
      onClickAction: onClickResetInput,
      cursor: 'pointer',
    },
  };

  const iconConfig = iconsConfig[iconType];

  return (
    <Box
      position="absolute"
      right={`${theme.ruler[3]}px`}
      onClick={iconConfig.onClickAction}
      backgroundColor={fillColor}
    >
      <Icon
        strokeColor={iconConfig.strokeColor}
        size="xs"
        fillColor={iconConfig.fillColor}
        icon={iconConfig.icon}
        cursor={iconConfig.cursor}
        data-qaid={`${qaId}-${iconType}`}
      />
    </Box>
  );
};
